import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Search from "./pages/Search";
import Donate from "./pages/Donate";
import Thanks from "./pages/Thanks";
import ReactGA from "react-ga";

const TRACKING_ID = "G-13J0LM1F7S";

ReactGA.initialize(TRACKING_ID, {
  gaOptions: {
    name: 'tracker1', // Optional tracker name
  },
});

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<Search />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/thanks" element={<Thanks />} />  
      </Routes>
    </Router>
  );
}

export default App;
